import { ThemeProvider } from "@mui/material";
import React, { FC, useContext, useEffect } from "react";
import { RouteObject, useMatch, useNavigate, useRoutes } from "react-router-dom";
import "./App.css";
import { theme } from "./mui-theme/create-theme";
import { routes } from "./routes/route-config";
import { Alert } from "./components/alert/alert";
import { useDispatch } from "react-redux";
import { GlobalHelper } from "./utils/helpers/global-helper";
import { ToastContext, ToastProvider } from "./components/pru-toast/toast-context";
import { LoadingComponent } from "./components/loading/loading.component";
import { updateGAData } from "./common/ga/redux/ga-slice";
import GAPanel from "./common/ga/components/ga-panel";
import { takeUIScreenViewEvent } from "./common/ga/ga";
import { linkOpen } from "./components/modal/link-open";
import { EVENT_OPEN_LINK_WITHIN_PAGE } from "./constants/constants";

document.addEventListener(EVENT_OPEN_LINK_WITHIN_PAGE, (event: any) => {
  const url = event?.detail?.url;
  if (!url) return;
  linkOpen({ url });
});
function App() {
  const dispatch = useDispatch();
  GlobalHelper.setGlobalDispatch(dispatch);
  const navigate = useNavigate();
  GlobalHelper.setGlobalNavigate(navigate);
  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <Alert />
        <Routes />
        <GAPanel debug />
      </ToastProvider>
      <LoadingComponent />
    </ThemeProvider>
  );
}
export default App;

const Routes: FC = () => {
  const element = useRoutes(routes);
  const match = useMatch("*");
  const dispatch = useDispatch();

  const toastRef = useContext(ToastContext);
  GlobalHelper.setGlobalToastRef(toastRef);
  useEffect(() => {
    const findRoute = (
      target: string,
      path: string,
      children?: RouteObject[],
    ): RouteObject | null => {
      if (!children) return null;

      const nextChild = children.find((val: any) => {
        return (
          val.path === "*" ||
          (val.path === "" && target === `${path}${val.path}`) ||
          (val.path !== "" && target.startsWith(`${path}/${val.path}`))
        );
      });

      if (!nextChild) return null;
      if (!nextChild.children) return nextChild;

      return findRoute(target, `${path}/${nextChild.path}`, nextChild.children);
    };

    const eleProps = element?.props;
    if (!eleProps || !match) return;

    const matchPathname = eleProps.match.pathname as string;
    const matchChildren = eleProps.match.route?.children as RouteObject[] | undefined;

    const currentRoute = findRoute(match.pathname, matchPathname, matchChildren);
    if (!currentRoute || !currentRoute.gaData) {
      return;
    }

    dispatch(updateGAData(currentRoute.gaData));
    takeUIScreenViewEvent(currentRoute.gaData);
  }, [match, element, dispatch]);

  return element;
};
